import Vue from 'vue'
import Router from 'vue-router'
import Communes from '../pages/Communes'
import ProchainPassage from '../pages/ProchainPassage'
import DetailCarte from '../pages/DetailCarte'
import Home from '../pages/Home'
import Horaires from '../pages/Horaires'
import Tarifs from '../pages/Tarifs'
import Reserver from '../pages/Reserver'
import Arrets from '../pages/Arrets'
import RecupCarte from '../pages/RecupCarte'
import Contact from '../pages/Contact'
import VueMatomo from 'vue-matomo'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '',
      name: 'Home',
      component: Home
    },
    {
      path: '/fiche-horaire',
      name: 'Horaires',
      component: Horaires
    },
    {
      path: '/reserver',
      name: 'Reserver',
      component: Reserver
    },
    {
      path: '/tarifs',
      name: 'Tarifs',
      component: Tarifs
    },
    {
      path: '/recuperation-carte',
      name: 'RecupCarte',
      component: RecupCarte
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/communes',
      name: 'Communes',
      component: Communes
    },
    {
      path: '/commune=:idZone',
      name: 'Arrets',
      component: Arrets
    },
    {
      path: '/arret=:stopName',
      name: 'ProchainPassage',
      component: ProchainPassage
    },
    {
      path: '/carte/:tripId/:stopId/:sequence',
      name: 'detailBus',
      component: DetailCarte
    }
  ]
})

Vue.use(VueMatomo, {
  host: 'https://pretapartir.matomo.cloud/',
  siteId: 11,
  trackerFileName: 'matomo',
  debug: false
})

router.afterEach((to, from) => {
  window._paq.push(['setCustomUrl', 'https://www.antoni-voyages.com/lr27-metz-express/#' + to.fullPath])
  window._paq.push(['trackPageView'])
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js